import styled from 'styled-components';

export const ErrorMessage = styled.p`
  color: ${({ theme }) => theme.config.error.color};
`;
